var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        hasFooter: false,
        closeOutside: false,
        titulo: "Visualizar demanda",
        width: 800
      },
      on: { closeModal: _vm.closeModal }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c(
            "el-row",
            { staticClass: "container", attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Número da demanda:")
                ]),
                _c("span", [_vm._v(_vm._s(_vm.demanda.numeroDemanda))])
              ])
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "container", attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "label" }, [_vm._v("Painel:")]),
                _c("span", [_vm._v(_vm._s(_vm.getPainelNome))])
              ])
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "container", attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Nome da demanda:")
                ]),
                _c("span", [_vm._v(_vm._s(_vm.demanda.nome))])
              ])
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "container", attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Data de início:")
                ]),
                _c("span", [
                  _vm._v(_vm._s(_vm.formatarData(_vm.demanda.dataInicio)))
                ])
              ]),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Data de entrega:")
                ]),
                _c("span", [
                  _vm._v(_vm._s(_vm.formatarData(_vm.demanda.dataEntrega)))
                ])
              ])
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "container", attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Estado da demanda:")
                ]),
                _c("span", [_vm._v(_vm._s(_vm.getEstadoDemanda))])
              ]),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("Prioridade:")]),
                  _c(
                    "el-tag",
                    {
                      staticClass: "tag demanda-text-color",
                      attrs: { color: _vm.getPrioridadeColor }
                    },
                    [_vm._v(_vm._s(_vm.getPrioridade))]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("Situação:")]),
                  _c(
                    "el-tag",
                    { attrs: { type: _vm.getSituacaoType, effect: "dark" } },
                    [_vm._v(_vm._s(_vm.getSituacao))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.demanda.descricao
            ? _c(
                "el-row",
                { staticClass: "container", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Descrição:")
                    ]),
                    _c("div", { staticClass: "container-disable" }, [
                      _c("p", [_vm._v(_vm._s(_vm.demanda.descricao))])
                    ])
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm.getAtividades
            ? _c(
                "el-row",
                { staticClass: "container", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Atividades:")
                    ]),
                    _c("div", { staticClass: "container-disable" }, [
                      _c(
                        "ul",
                        { staticClass: "vertical-ul" },
                        _vm._l(_vm.getAtividades, function(atividade) {
                          return _c(
                            "li",
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 1 } },
                                    [
                                      _c("el-checkbox", {
                                        attrs: { disabled: "disabled" },
                                        model: {
                                          value: atividade.concluido,
                                          callback: function($$v) {
                                            _vm.$set(
                                              atividade,
                                              "concluido",
                                              $$v
                                            )
                                          },
                                          expression: "atividade.concluido"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("el-col", { attrs: { span: 23 } }, [
                                    _c("span", [_vm._v(_vm._s(atividade.nome))])
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { staticClass: "padding-horizontal-10", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Responsáveis:")
                  ]),
                  [
                    _vm.getResponsaveis
                      ? _c(
                          "ul",
                          { staticClass: "horizontal-ul" },
                          _vm._l(_vm.getResponsaveis, function(responsavel) {
                            return _c(
                              "li",
                              [
                                _c(
                                  "el-tag",
                                  { staticClass: "tag responsavel-text-color" },
                                  [
                                    _vm._v(
                                      _vm._s(responsavel.pessoa.nomeRazaoSocial)
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _c("span", [
                          _vm._v(
                            "Não há responsáveis informados para esta demanda."
                          )
                        ])
                  ]
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fd63d0f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fd63d0f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/demandas/components/ModalVisualizarDemanda.vue
// module id = null
// module chunks = 